import { useContext } from 'react'
import AlertContext from '../../Store/Context/AlertContext'

const useAlert = () => useContext(AlertContext)

export default useAlert
